<script>
  import {
    Spinner,
    Input,
    ChoiceInput,
    Select,
    Pagination,
  } from "agnostic-svelte"
  import { navigate } from "svelte-routing"
  import { store } from "./store"
  import { getDisplay, getInNetwork, getBackground } from "../utils"
  import { isEqual, defaults, clone } from "lodash"

  export let location

  let search = Object.fromEntries(
    new URLSearchParams(location.search).entries()
  )

  search.year = Number(search.year) || undefined
  search.page = Number(search.page) || undefined

  let filters = defaults(clone(search), {
    year: 2023,
    order: "asc",
    page: 1,
  })
  console.log(search, filters)

  const apikey = "d687412e7b53146b2631dc01974ad0a4"

  $: counties = fetch(
    `https://marketplace.api.healthcare.gov/api/v1/counties/by/zip/${store.userd.zip}?apikey=${apikey}`
  ).then((v) => v.json())
  const quickopts = (o) =>
    o.map((v) =>
      Array.isArray(v)
        ? { value: v[0], label: v[1] }
        : { value: v, label: v.toString() }
    )

  const year_opts = quickopts([2020, 2021, 2022, 2023])
  const order_opts = quickopts([
    ["asc", "Ascending"],
    ["desc", "Descending"],
  ])

  let limit = 10,
    limit_opts = quickopts([10, 20, 30])

  $: {
    if (!isEqual(search, filters))
      navigate(`?${new URLSearchParams(filters)}`, {
        replace: true,
      })
  }

  $: offset = (filters.page - 1) * limit

  $: plansr = counties.then((counties) => {
    const c = counties.counties?.[0]
    if (!c) {
      console.error("No county found", counties)
      return
    }
    return fetch(
      `https://marketplace.api.healthcare.gov/api/v1/plans/search?apikey=${apikey}`,
      {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          household: {
            income: Number(store.userd.income),
            people: store.userd.people.map((p) => ({
              age: Number(p.age),
              gender: p.sex === "M" ? "Male" : "Female",
            })),
            has_married_couple: store.userd.people.some(
              (p) => p.name === "Spouse"
            ),
          },
          market: "Individual",
          place: {
            countyfips: c.fips,
            state: c.state,
            zipcode: c.zipcode,
          },
          limit: Number(limit),
          offset: Number(offset),
          order: filters.order,
          year: Number(filters.year),
        }),
      }
    ).then((v) => v.json())
  })
</script>

<div class="flex flex-column items-center" style="gap:1em">
  {#await plansr}
    <Spinner />
  {:then plansr}
    <Pagination
      bind:current={filters.page}
      total={Math.ceil(plansr.total / limit)}
    />
    <div class="flex " style="justify-content:space-around">
      <div class="flex flex-column p8" style="gap:.5em;text-align:left">
        <h3 style="text-align:center;margin-top:.4em">Filters</h3>

        <b>Year</b>
        <Select
          bind:singleSelected={filters.year}
          options={year_opts}
          labelCopy="Year"
        />
        <b>Order</b>
        <Select
          bind:singleSelected={filters.order}
          options={order_opts}
          labelCopy="Order"
        />

        <!-- <h4 >Limit</h4>
        <Select
          bind:singleSelected={limit}
          options={limit_opts}
          labelCopy="Limit"
        /> -->
      </div>
      <div class="flex flex-column plans" style="max-width: 400px;">
        {#each plansr.plans as plan}
          <button
            on:click={() => navigate(`/plans/${plan.id}`)}
            class="round p0 plan"
            style="max-width:100%;overflow:hidden"
          >
            <div class="flex badges">
              <div style="background: #2969cf55; padding-block:12px"><b>${plan.premium}</b></div>
              <div style="background: #2969cf55; padding-block:12px">
                <b>${plan.deductibles?.[0]?.amount}</b>
              </div>
              <div style="padding-block:12px">{plan.metal_level}</div>
            </div>

            <div style="padding:10px;padding-block: 12px">
              <b>{plan.name}</b>
            </div>
            <div style="background: #2969cf55; width:100%; padding-block: 8px">
              {plan.issuer.name}
            </div>
            <div class="flex badges-b">
              <div>
                {plan.quality_rating.available
                  ? `Rating ${(
                      plan.quality_rating?.[`global_rating`] || 0
                    ).toFixed(0)} / 5`
                  : `No Rating`}
              </div>
              <a
                style="display:inline-block; padding:.7em"
                target="_blank"
                on:click={(e) => e.stopPropagation()}
                href={plan.network_url}>Network</a
              >
              <a
                style="display:inline-block; padding:.7em"
                target="_blank"
                on:click={(e) => e.stopPropagation()}
                href={plan.benefits_url}>SBCs</a
              >
            </div>
            <div style="background: #2969cf55; width:100%; opacity: 0.7">In-Network</div>
            <div class="flex badges-b" style="opacity: 0.7">
              <div
                style:background={getBackground(
                  getInNetwork(plan, "Generic Drugs")
                )}
              >
                <div><b>Drugs</b></div>
                <div>
                  {getDisplay(getInNetwork(plan, "Generic Drugs"))}
                </div>
              </div>
              <div
                style:background={getBackground(
                  getInNetwork(plan, "Specialist Visit")
                )}
              >
                <div><b>Specialist</b></div>
                <div>
                  {getDisplay(getInNetwork(plan, "Specialist Visit"))}
                </div>
              </div>
              <div
                style:background={getBackground(
                  getInNetwork(plan, "Emergency Room Services")
                )}
              >
                <div><b>Emergency</b></div>
                <div>
                  {getDisplay(getInNetwork(plan, "Emergency Room Services"))}
                </div>
              </div>
              <div
                style:background={getBackground(
                  getInNetwork(
                    plan,
                    "Primary Care Visit to Treat an Injury or Illness"
                  )
                )}
              >
                <div><b>Primary</b></div>
                <div>
                  {getDisplay(
                    getInNetwork(
                      plan,
                      "Primary Care Visit to Treat an Injury or Illness"
                    )
                  )}
                </div>
              </div>
            </div>
          </button>
        {/each}
      </div>
    </div>

    <Pagination
      bind:current={filters.page}
      total={Math.ceil(plansr.total / limit)}
    />
  {/await}
</div>

<style>
  .plans {
    align-items: stretch;
    gap: 1em;
  }
  .badges,
  .badges-b {
    align-items: center;
    justify-content: space-around;
  }
  .badges {
    border-bottom: 1px solid;
  }
  .badges-b {
    /* border-top: 1px solid; */
  }
  .badges > *,
  .badges-b > * {
    flex: 1 1 auto;
    border-left: 1px solid;
  }
  .badges > *:first-child,
  .badges-b > *:first-child {
    border-left: initial;
  }
  .plan{
    outline: 2px solid var(--border);
  }
</style>
